// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".building-footer{\n    margin-top: 2rem;\n}\n.building-footer__message{\n    text-align: center;\n}\n\n.advertisement-banner{\n    background: black;\n    color:white;\n\n    margin-left:-30px;\n    margin-right:-30px;\n\n    position:relative;\n}\n", ""]);
// Exports
module.exports = exports;
